var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-container"},_vm._l((_vm.styles),function(item,index){return _c('div',{key:index,staticClass:"navigation"},[(item.isEnable)?_c('router-link',{attrs:{"to":item.to}},[_c('div',{staticClass:"item",class:{ selected: _vm.currentSection == item.param }},[_vm._v(" "+_vm._s(item.title)+" ")])]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }